import React, { useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import consultation from '../../../images/consultation.png';
import calender from '../../../images/calender.png';
import time from '../../../images/time.png';
import location from '../../../images/location.png';
import phone from '../../../images/phone.png';
import pateint1 from '../../../images/patient1.png';
import OTP from './otp';
import Details from './details';

const Progress = () => {
  const [height, setHeight] = useState(0);
  const [value, setValue] = useState(0);

  const clicked = () => {
    setValue(1);

  }

  return (
    <div>
      <Header setHeight={setHeight} />
      <div
        className="profile_crumb"
        style={{ height: height + 10 + "px" }}
      ></div>
      <div className="profile_page pb-5">
        <section className="py-5">
          <div className="container mt-5">
            <div className="w-85 bg-white shadow rounded_outer mx-auto">
              <div className="pb-3 pt-3">

                <div className="row progressAppointment">
                  <div className="col-lg-6 col-md-12 border-right">

                    <div className="row pt-5 col-md-justify-content-center">
                      <div className="col-lg-2"></div>
                      <div className="col-lg-8 col-md-6">
                        <div className="appointmentBody1 w-100 d-flex align-items-center">
                          <img className="mr-4" style={{ width: "50px" }} src={consultation} alt="icon" />
                          <div className="appointmentSubBody1">
                            <span className="h4heading font-weight-bold" style={{ padding: "0" }}>In-Clinic Appointment</span><br />
                            <span className="my-2 h3desc align-middle">
                              <span className="mr-5 font-weight-normal"> <img src={calender} alt="calender icon" /> Nov 30, 2020 </span>
                              <span className="font-weight-normal"> <img src={time} alt="calender icon" /> At 01:00AM </span>
                            </span>
                          </div>
                        </div>
                        <p className="h5heading pt-1 responsive-center" style={{ color: "#25BCA7" }}>Change date and Time</p>
                      </div>
                      <div className="col-lg-2"></div>
                    </div>

                    <hr />

                    <div className="row pb-5 col-md-justify-content-center">
                      <div className="col-lg-2"></div>
                      <div className="col-lg-8 col-md-6">
                        <div className="appointmentBody2 w-100 d-flex align-items-center">
                          <img className="mr-3" style={{ width: "50px" }} src={pateint1} alt="icon" />
                          <div className="appointmentSubBody1">
                            <h2 className="h4heading font-weight-bold" style={{ padding: "0" }}>Colin Bastick</h2>
                            <h4 className="h2desc"> Primary Care Doctor</h4>

                            <span className="my-2 h3desc align-middle">
                              <span className="mr-5 font-weight-normal"> <img src={location} alt="calender icon" /> New York </span>
                              <span className="font-weight-normal"> <img src={phone} alt="calender icon" /> +880 415 47854 </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-2"></div>
                    </div>
                  </div>
                  {/* left end */}

                  {/* right side */}
                  {value === 0 ?
                    <OTP clicked={clicked} />
                    :
                    <Details />
                  }


                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Progress;

